import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  makeStyles,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { Renewal } from 'interface/offers';
import { SyntheticEvent } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    width: 437,
    '@media(max-width: 420px)': {
      width: 300,
    },
  },
  dialogTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      paddingRight: 24,
    },
  },
  dialogTitle: {
    color: theme.palette.primary.main,
    fontSize: 16,
    fontWeight: 600,
    padding: '24px 0 24px 24px',
    '& h2': {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 340,
      '@media(max-width: 420px)': {
        width: 200,
      },
    },
  },
  dialogContent: {
    padding: ' 8px 24px',
  },
  dialogContentText: {
    fontSize: 15,
    fontWeight: 600,
    '& p': {
      color: theme.palette.grey[600],
      margin: 0,
      marginLeft: 8,
    },
  },
  dialogActions: {
    padding: 24,
    '& button': {
      fontSize: 14,
      fontWeight: 600,
      padding: '9.5px 16px',
      textTransform: 'none',
      '@media(max-width: 420px)': {
        fontSize: 10,
      },
    },
  },
}));

interface IProps {
  renewal: Renewal;
  moreThanOneOffer: boolean;
  openRenewalModal: boolean;
  handleCloseCancel: () => void;
  openSelectOffer: () => void;
  handleCheckIfPaymentIsPending: (event: SyntheticEvent) => void;
}

const MainOfferModal = ({
  renewal,
  moreThanOneOffer,
  openRenewalModal,
  handleCloseCancel,
  openSelectOffer,
  handleCheckIfPaymentIsPending,
}: IProps) => {
  const classes = useStyles();

  renewal.formattedPrice = renewal?.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  return (
    <Dialog
      open={openRenewalModal}
      onClose={handleCloseCancel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <div className={classes.container}>
        <div className={classes.dialogTitleContainer}>
          <DialogTitle className={classes.dialogTitle}>{renewal?.title}</DialogTitle>
          <IconButton aria-label='close' onClick={handleCloseCancel}>
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className={classes.dialogContent}>
          <DialogContentText className={classes.dialogContentText}>
            <p>
              Por <strong>{renewal?.formattedPrice}</strong>, garanta acesso ao seu curso por mais
              <strong> {renewal?.validity}</strong> dias!
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {moreThanOneOffer && <Button onClick={openSelectOffer}>Ver outra oferta</Button>}
          <Button variant='contained' color='primary' onClick={handleCheckIfPaymentIsPending}>
            Quero renovar!
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default MainOfferModal;
